import { Footer } from '@/components/Footer/Footer';
import { TariffCalculator } from '@/components/TariffCalculatorNew/TariffCalculator';

export default function TariffPage() {
	return (
		<>
			<TariffCalculator />;
			<Footer />
		</>
	);
}
